import HomeFooterNavigationLinks from "./HomeFooterNavigationLinks";
import HomeFooterBottomLinks from "./HomeFooterBottomLinks";
import SystemCustomDivider from "../../dividers/SystemCustomDivider";

export default function HomeFooter() {
    // Used in HomeScreen to display bottom
    // part of HomeScreen

    // BUILD
    return (
        <footer className={"bg-white w-full flex flex-col justify-center items-center py-[48px]"}>
            <div className={"w-full max-w-[1200px] px-[48px]"}>
                <HomeFooterNavigationLinks />
                <SystemCustomDivider color={"bg-backgroundLight5"}
                                     extraClass={"mt-[16px]"} />
                <HomeFooterBottomLinks />
            </div>
        </footer>
    );
}